import { render, staticRenderFns } from "./CreateGroup.vue?vue&type=template&id=4e7a86df&scoped=true&"
import script from "./CreateGroup.vue?vue&type=script&lang=ts&"
export * from "./CreateGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CreateGroup.vue?vue&type=style&index=0&id=4e7a86df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7a86df",
  null
  
)

component.options.__file = "CreateGroup.vue"
export default component.exports